__turbopack_context__.v({
  "background": "hero-module__Xzq-xW__background",
  "comingSoon": "hero-module__Xzq-xW__comingSoon",
  "content": "hero-module__Xzq-xW__content",
  "hero": "hero-module__Xzq-xW__hero",
  "hide": "hero-module__Xzq-xW__hide",
  "show": "hero-module__Xzq-xW__show",
  "text": "hero-module__Xzq-xW__text",
  "virtualLabsButton": "hero-module__Xzq-xW__virtualLabsButton",
});
